<template>
  <div v-if="backgroundImage" class="wrapper">
    <el-row>
      <el-col :style="{ backgroundImage: 'url(' + backgroundImage + ')' }" :xs="{ span: 24, offset: 0 }"
        :sm="{ span: 22, offset: 1 }" :md="{ span: 18, offset: 3 }" :lg="{ span: 18, offset: 3 }" class="selector">
        <div class="content">
          <h2 class="light">{{ headline }}</h2>
          <el-row class="text">
            <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 18, offset: 3 }"
              :lg="{ span: 12, offset: 6 }" class="light"
              v-html="text" /><!-- eslint-disable-line vue/no-v-text-v-html-on-component -->
          </el-row>
          <router-link to="/training">
            <el-button type="primary">
              {{ linkText }}
            </el-button>
          </router-link>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import products from '.';
import { mapState } from 'vuex';

export default {
  name: 'ProductSalesTrainingCta',
  computed: {
    ...mapState(products.store.namespace, [
      'productsOverview'
    ]),
    headline() {
      return this.productsOverview.productsOverviewTrainingCTAHeadline
    },
    text() {
      return this.productsOverview.productsOverviewTrainingCTAText
    },
    linkText() {
      return this.productsOverview.productsOverviewTrainingCTALinkText
    },
    backgroundImage() {
      return (this.productsOverview.productsOverviewTrainingCTAImage &&
        this.productsOverview.productsOverviewTrainingCTAImage.length) ?
        this.productsOverview.productsOverviewTrainingCTAImage[0].url
        : '';
    },
  },
}

  ////////


</script>

<style lang="scss" scoped>
@import 'element-theme-chalk/src/mixins/mixins.scss';
@import '@/assets/base/_variables.scss';

.content {
  text-align: center;
  padding: 100px 0px;
}

.text {
  margin-bottom: 50px;
}

h2 {
  margin-bottom: 30px;
}

.wrapper {
  margin-bottom: 100px;
}

@include res(md-and-down, $--breakpoints-spec) {

  h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  .text {
    margin-bottom: 35px;
  }

  .content {
    padding: 65px 0px;
  }

}
</style>
